<template>
  <h1>Help Center Component</h1>
</template>

<script lang="ts" setup></script>
